import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import Button from "../componentLibrary/Button";
import { useGetLegalDates } from "../api/queries";
import PrivacyContent from "./legal/PrivacyContent";

interface PrivacyPolicyModalProps {
  open: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  open,
  onClose,
}) => {
  const { data: legalDates } = useGetLegalDates();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { maxHeight: "80vh" },
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="h2">
          Psych for Life<sup>®</sup> Privacy Notice
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Last updated:{" "}
          {legalDates?.privacyLastUpdated
            ? new Date(legalDates.privacyLastUpdated).toLocaleDateString()
            : "Loading..."}
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <PrivacyContent showLastUpdated={false} />
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyPolicyModal;
